import { render, staticRenderFns } from "./TablaInscripcionesCompletasPorAsesores.vue?vue&type=template&id=05c05e34&scoped=true"
import script from "./TablaInscripcionesCompletasPorAsesores.vue?vue&type=script&lang=js"
export * from "./TablaInscripcionesCompletasPorAsesores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c05e34",
  null
  
)

export default component.exports